import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, Progress } from "antd"
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'
import { createHWBox } from '../../../../services/api/apiBatchShip'

CreateMultiBoxHW.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func.isRequired
}

function CreateMultiBoxHW(props) {
    const { visible, onCancel, selectedItems, setSelectedItems, reload } = props
    const [loading, setLoading] = useState(false)
    const [listSuccess, setListSuccess] = useState([])
    const [listError, setListError] = useState([])


    const _onChangeCreateBoxHW = async (id) => {
        try {
            
            const { data:response} = await createHWBox(id)

            const { data, success, message } = response

            if (!success) {
                return { success: success, message: message }
            }

            return { data, success: success }
        } catch (e) {
            return { success: false, message: e.message }
        }
    }

    const _onSubmitChange = async () => {
        setLoading(true)
        setListSuccess([])
        setListError([])
        setSelectedItems(selectedItems.map(i=>{
            delete i.processing
            delete i.success
            delete i.error
            return i
        }))

        let processed = []

        await Promise.all(selectedItems.map(async item => {
            const response = await _onChangeCreateBoxHW(item._id)

            const { data, success, message} = response

            if (!success) return processed.push({ ...item, error: message, processing: false })
        
            const {batch_ship} = data
            const {partner_box_status} = batch_ship

            if(partner_box_status && partner_box_status === 'done'){
                return processed.push({ ...item, success: true, processing: false })
            }

            return processed.push({ ...item, error: 'Create unsuccess', processing: false })
        }))

        let newListSuccess = []
        let newListError = []

        processed.map(process => {
            if (process.success === true) {
                return newListSuccess.push(process)
            }

            if (process.error.length > 0) {
                return newListError.push(process)
            }
        })

        setListSuccess(newListSuccess)
        setListError(newListError)
        setLoading(false)
        setSelectedItems(processed)
        reload()
    }

    const handleCloseModal = () => {
        onCancel()
        setListSuccess([])
        setListError([])
        setSelectedItems(selectedItems.map(i=>{
            delete i.processing
            delete i.success
            delete i.error
            return i
        }))
    }

    return (
        <Modal
            className="CreateMultiBoxLLCModal"
            visible={visible}
            title="Tạo thùng HW"
            onOk={_onSubmitChange}
            width='780px'
            onCancel={handleCloseModal}
            footer={[
                <Button key="back" disabled={loading} onClick={handleCloseModal}>
                    Cancel
                </Button>,
                <Button key="submit" disabled={loading|| (!!listSuccess.length || listError.length)}  type="primary" loading={loading} onClick={_onSubmitChange}>
                    Tạo thùng HW
                </Button>
            ]}
        >
            <h3>List processing <span>{selectedItems.length}</span> items</h3>
            {
                (listSuccess.length > 0 || listError.length > 0) &&
                <div className="Results">
                    <div className="ResultSuccess">
                        Success: <span>{listSuccess.length}</span> items
                    </div>
                    <div className="ResultError">
                        Error: <span>{listError.length}</span> items
                    </div>
                </div>
            }

            <div className="ListProcessing">
                <ul>
                    {
                        !!selectedItems && selectedItems.length > 0 && selectedItems.map(item => (
                            <li key={item._id}>
                                <span className='font-weight-bold'>#{item.id}</span>
                                {
                                    !!item.error &&
                                    <span className="Error"><ExclamationCircleOutlined /> {item.error}</span>
                                }
                                {
                                    item.success &&
                                    <span className="Success"><CheckCircleOutlined /> Create success</span>
                                }
                                <Progress
                                    percent={(!!item.success || !!item.error) ? 100 : 0}
                                    size="small"
                                    status={`${(item.processing === false && item.success === true) ? 'success' : ((item.processing === false && item.error.length > 0) ? 'exception' : 'active')}`}
                                    showInfo={false}
                                />
                            </li>
                        )
                        )
                    }
                </ul>
            </div>
        </Modal>
    )
}

export default CreateMultiBoxHW
